import { AuthGuard } from "../../shared/guards/AuthGuard";
import { Sidebar } from "../../shared/components";
import { CollectionControlListPresentation } from "./components/CollectionControlListPresentation";

export const CollectionControlPage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<CollectionControlListPresentation />
			</Sidebar>
		</AuthGuard>
	);
};
